import React from 'react'

import { fromInteger, getLogoForCoin } from '@src/service/coins/coins'
import { useTranslation } from 'react-i18next'
import { CoinListRow, CoinImage, CoinText, BalanceBlock } from './ListView.styled'
import { useSelector } from 'react-redux'
import { IStore } from '@src/store'
import { getSpecialBonusData } from './ListView.utils'

import { useAuthUser } from "@src/stores/auth"

interface SpecialBonusI {
  isGamblerWalletActive: boolean
  onSpecialBonusClick: () => void
}
export const SpecialBonus = ({ isGamblerWalletActive, onSpecialBonusClick }: SpecialBonusI) => {
  const { t } = useTranslation()
  const wallet = useSelector((store: IStore) => store.wallet)
  const user = useAuthUser()

  const { balance, currency } = React.useMemo(
    () => getSpecialBonusData(user, wallet),
    [user, wallet],
  );
  if (balance <= 0) return null

  return (
    <CoinListRow key={'wallet-list-x' + currency} $isActive={isGamblerWalletActive} onClick={onSpecialBonusClick}>
      <div className="flex">
        <CoinImage alt={currency} src={getLogoForCoin(currency)} />
        <CoinText className="coin">{t('wallet.listView.specialBonus', 'SPECIAL BONUS')}</CoinText>
      </div>
      <BalanceBlock>{fromInteger(balance, currency)}</BalanceBlock>
    </CoinListRow>
  )
}
